import { useInAppNavigate } from '@Alias/hooks';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setIsUserInPhiloSupportedGeoRegion, setUserLocation } from '../../redux/actions/auth';
import { RESPONSE_STATUS_FAIL } from '../../utils/auth-errors';
import { NOOP } from '../../utils/defaults';
import { fetchWithRetry } from '../../utils/promise';
import { GEO_FENCE_NESTED } from '../../utils/router';

export const LOAD_USER_GEO_LOCATION_URL = 'https://content-us-east-2-fastly-b.www.philo.com/geo';

/** KU
 *
 * Returns a handler, {@link handleLoadUserGeolocation}, which determines if the
 * user is in a Philo-supported region. If they are not,
 * {@link handleLoadUserGeolocation} redirects them to `/unavailable`.
 */
export default function useLoadUserGeolocation() {
  const dispatch = useDispatch();
  const navigate = useInAppNavigate();

  const handleLoadUserGeolocation = useCallback(() => {
    fetchWithRetry(LOAD_USER_GEO_LOCATION_URL, {})
      .then(response => response.json())
      .then(json => {
        if (json.status === RESPONSE_STATUS_FAIL) {
          dispatch(setIsUserInPhiloSupportedGeoRegion(false));
          navigate(GEO_FENCE_NESTED);
        } else {
          dispatch(setUserLocation(json.city));
        }
      })
      .catch(NOOP);
  }, []);

  return { handleLoadUserGeolocation };
}
